export default __webpack_public_path__ + "static/media/screenBlock10.7c32d674.jpg";